//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { Mixins } from '@theme/mixins';

/**
 * The StatBubbleSheet atom renders a background sheet for a StatBubble container.
 */
export const StatBubbleSheet = ({
  children,
  className,
}: React.HTMLAttributes<HTMLDivElement>) => {
  return <Sheet className={className}>{children}</Sheet>;
};

const Sheet = styled.div(
  ({ theme }) => `
  ${Mixins.Sheet.Low}
  display: flex;
  flex-direction: column;
  padding: ${theme.spacings[3]};
`,
);

export default StatBubbleSheet;
